var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',{attrs:{"show-app-preview":false}},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"alt":"Hellocare","src":require("../assets/images/logo.png")}}),_c('h1',[_vm._v("Cette page n'existe pas")])])])}
var staticRenderFns = []

export { render, staticRenderFns }